import React, { useState, useEffect } from "react";
import './events.css';

const EventsWithSchools = () => {
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: "",
        grade: "",
        age: "",
        date_of_birth: '',
  gender: '',
  parent_name: '',
  relation: '',
  parent_contact: '',
  parent_email: '',
        physical_sport: "",
        mind_sport: "",
        terms: false,
    });
    const [razorpayLoaded, setRazorpayLoaded] = useState(false); // Track if Razorpay SDK is loaded
    const [idCardFile, setIdCardFile] = useState(null); // <-- Add this line here

    const schools = [
        { id: 1, name: "VIBGYOR Group of High Schools", logo: "https://esmaaash.in/esmaaash_web/uploads/schools/VIBGYOR.png", description: "Annual inter-school events at VIBGYOR Group of High Schools." },
        { id: 2, name: "Bombay Cambridge International School", logo: "https://esmaaash.in/esmaaash_web/uploads/schools/Bombay.png", description: "Participate in competitive and fun games at Bombay Cambridge International School." },
        { id: 3, name: "M.K.N Bhatia High School & Jr. College", logo: "https://esmaaash.in/esmaaash_web/uploads/schools/MKN.jpg", description: "Join the sports carnival at M.K.N Bhatia High School & Jr. College." },
        { id: 4, name: "Shri Balaji International School", logo: "https://esmaaash.in/esmaaash_web/uploads/schools/ShriBalaji.png", description: "Exciting sports events and activities at Shri Balaji International School." },
    ];

    useEffect(() => {
        // Dynamically load Razorpay SDK if it's not already loaded
        if (!window.Razorpay) {
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => {
                console.log("Razorpay SDK loaded successfully");
                setRazorpayLoaded(true); // Set Razorpay as loaded when the script is loaded
            };
            script.onerror = () => {
                console.error("Failed to load Razorpay SDK");
                alert("Failed to load Razorpay SDK. Please try again later.");
                setRazorpayLoaded(false); // Set to false if the SDK fails to load
            };
            document.body.appendChild(script);
        } else {
            setRazorpayLoaded(true); // If Razorpay is already available, set it as loaded
        }
    }, []);

    const handleSchoolClick = (school) => {
        setSelectedSchool(school);
    };

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

   const openRazorpay = (orderId) => {
    if (!razorpayLoaded) {
        alert("Razorpay SDK is not loaded yet. Please try again later.");
        return;
    }

    const options = {
        key: "rzp_test_OAtqa1yZ1iyOA6",
        amount: 200000,
        currency: "INR",
        name: "Smaaash School Events",
        description: "Event Registration Payment",
        order_id: orderId,
        handler: function (response) {
            // Log response to check if payment ID and Order ID are received
            console.log("Payment ID:", response.razorpay_payment_id);
            console.log("Order ID:", response.razorpay_order_id);

            // Send payment success details to backend
            fetch("https://esmaaash.in/esmaaash_web/backend/api/razorpay_payment_success.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_order_id: response.razorpay_order_id
                }),
            })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    alert("Thank you for registering!");
                    window.location.href = data.redirect;
                } else {
                    alert("Payment processed, but failed to save in DB.");
                }
            })
            .catch((error) => {
                console.error("Error saving payment success:", error);
                alert("Payment was successful, but there was an issue saving your registration.");
            });
        },
        prefill: {
            name: formData.name,
            contact: formData.mobile,
        },
        notes: {
            school: selectedSchool.name,
            grade: formData.grade,
        },
        theme: {
            color: "#4A88D2",
        },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
};


   const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.terms) {
        alert("Please agree to the Terms & Conditions before submitting.");
        return;
    }

    if (!selectedSchool) {
        alert("Please select a school before submitting.");
        return;
    }

    if (!razorpayLoaded) {
        alert("Razorpay SDK is not loaded yet. Please wait and try again.");
        return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("school_name", selectedSchool.name);
    formDataToSend.append("name", formData.name);
    formDataToSend.append("mobile", formData.mobile);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("grade", formData.grade);
    formDataToSend.append("age", formData.age);
    formDataToSend.append("physical_sport", formData.physical_sport);
    formDataToSend.append("mind_sport", formData.mind_sport);
    formDataToSend.append("date_of_birth", formData.date_of_birth);
formDataToSend.append("gender", formData.gender);
formDataToSend.append("parent_name", formData.parent_name);
formDataToSend.append("relation", formData.relation);
formDataToSend.append("parent_contact", formData.parent_contact);
formDataToSend.append("parent_email", formData.parent_email);

    
    if (idCardFile) {
    formDataToSend.append("id_card", idCardFile); // Add this line
}

    try {
        const response = await fetch("https://esmaaash.in/esmaaash_web/backend/api/save_school_event_registration.php", {
            method: "POST",
            body: formDataToSend,
        });

        const text = await response.text();
        console.log("Response text:", text);

        const result = JSON.parse(text);

        if (result.success && result.orderId) {
            openRazorpay(result.orderId);
        } else {
            alert("Submission failed: " + result.message);
        }
    } catch (err) {
        console.error("Error:", err);
        alert("Something went wrong with the registration. Please try again.");
    }
};

    return (
        <div className="registration-container">
            {!selectedSchool ? (
                <div className="school-list">
                    <h1>Select Your School</h1>
                    <div className="school-cards">
                        {schools.map((school) => (
                            <div key={school.id} className="school-card" onClick={() => handleSchoolClick(school)}>
                                <div className="school-card-content">
                                    <img
                                        src={school.logo || "https://via.placeholder.com/150"}
                                        alt={school.name}
                                        className="school-logo"
                                    />
                                    <div className="school-info">
                                        <h3>{school.name}</h3>
                                        <p>{school.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="school-details-container">
                    <h1 className="registration-title">Register for {selectedSchool.name}</h1>
                    <form onSubmit={handleSubmit} className="registration-form">
                        <div className="form-field">
                            <label>Student Name</label>
                            <input type="text" name="name" value={formData.name} onChange={handleFormChange} required />
                        </div>

                        <div className="form-field">
                            <label>Mobile Number</label>
                            <input type="text" name="mobile" value={formData.mobile} onChange={handleFormChange} required />
                        </div>

<div className="form-field">
    <label>Email</label>
    <input type="email" name="email" value={formData.email} onChange={handleFormChange} required />
</div>

                      


<div className="form-field">
  <label>Standard</label>
  <select
    name="grade"
    value={formData.grade}
    onChange={handleFormChange}
    className="w-full border rounded p-2"
  >
    <option value="">Select Class</option>
    {[4, 5, 6, 7, 8, 9].map((num) => (
      <option key={num} value={`Class ${num}`}>
        {`Class ${num}`}
      </option>
    ))}
  </select>
</div>

  
  
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                        <div className="form-field">
    <label>Date of Birth</label>
    <input type="date" name="date_of_birth" value={formData.date_of_birth} onChange={handleFormChange}
 className="w-full border rounded p-2" />
  </div>

                        <div className="form-field">
    <label>Gender</label>
    <select name="gender" value={formData.gender} onChange={handleFormChange} className="w-full border rounded p-2">
      <option value="">Select</option>
      <option value="Boy">Boy</option>
      <option value="Girl">Girl</option>
      <option value="Other">Other</option>
    </select>
  </div>

                        <div className="form-field">
                            <label>Age</label>
                            <input type="number" name="age" value={formData.age} onChange={handleFormChange} required />
                        </div>

                        <div className="form-field">
                            <label>Physical Sport</label>
                            <select name="physical_sport" value={formData.physical_sport} onChange={handleFormChange} required>
                                <option value="">Select Sport</option>
                                <option value="Cricket">Cricket</option>
                                <option value="Bowling">Bowling</option>
                            </select>
                        </div>

                        <div className="form-field">
                            <label>Mind Sport</label>
                            <select name="mind_sport" value={formData.mind_sport} onChange={handleFormChange} required>
                                <option value="">Select Sport</option>
                                <option value="Rubik Cube">Rubik Cube</option>
                                <option value="Chess">Chess</option>
                            </select>
                        </div>
                        
                        <div className="form-field">
    <label>Upload Student ID Card</label>
    <input
        type="file"
        name="id_card"
        accept=".jpg,.jpeg,.png,.pdf"
        onChange={(e) => setIdCardFile(e.target.files[0])}
        required
    />
</div>



                        <div className="form-field">
    <label>Parent’s Name</label>
    <input type="text" name="parent_name" value={formData.parent_name} onChange={handleFormChange} className="w-full border rounded p-2" />
  </div>

                        <div className="form-field">
    <label>Relation</label>
    <select name="relation" value={formData.relation} onChange={handleFormChange} className="w-full border rounded p-2">
      <option value="">Select</option>
      <option value="Father">Father</option>
      <option value="Mother">Mother</option>
      <option value="Guardian">Guardian</option>
    </select>
  </div>

                        <div className="form-field">
    <label>Parent Contact Number (WhatsApp)</label>
    <input type="tel" name="parent_contact" value={formData.parent_contact} onChange={handleFormChange} className="w-full border rounded p-2" />
  </div>

                        <div className="form-field">
    <label>Parent Email Address</label>
    <input type="email" name="parent_email" value={formData.parent_email} onChange={handleFormChange} className="w-full border rounded p-2" />
  </div>
</div>



                       <div className="form-field">
  <p style={{ fontWeight: "bold", marginBottom: "10px", color: "black" }}>
    Fees: ₹2000
  </p>
  </div>
 <label style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "5px" }}>
  <input
    type="checkbox"
    name="terms"
    checked={formData.terms}
    onChange={handleFormChange}
    required
    style={{ margin: 0 }}
  />
  <span>
    I agree to the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
  </span>
</label>




                        <button type="submit" className="submit-button">Submit & Pay</button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default EventsWithSchools;
